
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsc671f664e252a0252f9056bbf3de51b3en from './en.yaml'
            i18n.addResourceBundle('en', 'c671f664e252a0252f9056bbf3de51b3', flattenObject(nsc671f664e252a0252f9056bbf3de51b3en), true, true);
        
        export default 'c671f664e252a0252f9056bbf3de51b3';
    